import { FunctionComponent, JSX } from 'react';
import ExampleBanner from '../ExampleBanner';
import GhostBanner from '../GhostBanner';

export interface BannerWrapperProps {
  children: JSX.Element;
}

const BannerWrapper: FunctionComponent<BannerWrapperProps> = function ({
  children,
}) {
  return (
    <>
      <GhostBanner />
      <ExampleBanner />
      {children}
    </>
  );
};

export default BannerWrapper;
